import React ,{useEffect,useState} from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Button, Modal } from "reactstrap";





export  const ProductAwardHubspot=(props)=> {
  
  const {handleClose, handleSave, value } = props;
  //console.log(props)
  const [open, Setopen] = useState(true)
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const closeOpen=(e)=>{
    e.preventDefault();
    props.closeUserView();
    Setopen(false);
  }
  
  return (
    <div>
      <Modal className="modal-dialog-centered" style={{maxWidth:"1379px",maxHeight:"560px"}} isOpen={open}>
          <div className="modal-header">
           {/* <strong>HubSpot window</strong> */}
            <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={ closeOpen}>
              <span aria-hidden={true}>×</span>
            </button>
          </div>
   
   <div id="formDiv" style={{paddingLeft:"5px"}}>
    {
     value == 'efea3151-7f19-4b64-bf71-0a9bd4b2e8fa' ? 
     <iframe src='/hubsportCircularInitiativeAward.html' style={{width:"1260px",height:"560px", marginLeft:"50px"}}></iframe>
     :
     <iframe src='/hubsportProductLaunchAward.html' style={{width:"1260px",height:"560px", marginLeft:"50px"}}></iframe>
    }
    

    {/* <iframe src={'/hubsportAward.html?"'+value} style={{width:"1260px",height:"560px", marginLeft:"50px;"}}></iframe> */}
   </div>
          <div className="modal-footer">
          {/* <Button color="primary" type="button" onClick={()=>handleSave(value)}>Ok</Button> */}
          <Button color="secondary" data-dismiss="modal" type="button"  onClick={closeOpen}>Close</Button>
          </div>
        </Modal>
    </div>
  );
}

export default  ProductAwardHubspot;